import { render, staticRenderFns } from "./AddCustomerGroup.vue?vue&type=template&id=135c8a48&"
import script from "./AddCustomerGroup.vue?vue&type=script&lang=js&"
export * from "./AddCustomerGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports